import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { fileUrl } from '@/lib/api';

export default function ServiceCard({ category }) {
  return (
    <Link
      to={`/services/${category.slug}`}
      data-testid={`service-card-${category.slug}`}
      className="group block bg-white rounded-2xl overflow-hidden border border-[#E6E9EE] shadow-[0_10px_30px_rgba(11,18,32,0.06)] card-hover"
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-[#F2F7F5]">
        <img
          src={fileUrl(category.image)}
          alt={category.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform-only group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/0 to-black/0" />
      </div>
      <div className="p-5">
        <div className="font-headline text-xl text-[#17352D]">{category.name}</div>
        <div className="mt-1.5 text-sm text-slate-600 line-clamp-2">{category.tagline}</div>
        <div className="mt-4 flex items-center justify-between">
          <div className="text-xs uppercase tracking-[0.18em] text-slate-500">{category.sub_services?.length || 0} services</div>
          <div className="inline-flex items-center gap-1 text-sm font-semibold text-[#255244] group-hover:gap-2 transition-all-duration-200">
            View Services <ArrowRight className="h-4 w-4" />
          </div>
        </div>
      </div>
    </Link>
  );
}
